import ICache from './ICache';

export class ImageQueue implements ICache {
  private imgSrcQueue: string[] = [];
  private static instance: ImageQueue;

  static getInstance(): ImageQueue {
    if (!this.instance) {
      this.instance = new ImageQueue();
    }
    return this.instance;
  }

  private constructor() { }

  includes(src: string) {
    return this.imgSrcQueue.includes(src);
  }

  push(src: string) {
    this.imgSrcQueue.push(src);
  }

  list() {
    return this.imgSrcQueue;
  }

  size() {
    return this.imgSrcQueue.length;
  }

  clear() {
    this.imgSrcQueue = [];
  }
}

export class ImageCache implements ICache {
  private caches: any[] = [];
  private static instance: ImageCache;

  private constructor() { }

  public static getInstance() {
    if (!this.instance) {
      this.instance = new ImageCache();
    }
    return this.instance;
  }

  includes(src: string) {
    return this.caches.includes(src);
  }

  push(src: string) {
    this.caches.push(src);
  }

  list() {
    return this.caches;
  }

  size() {
    return this.caches.length;
  }

  clear() {
    this.caches = [];
  }

  addAll(srcList: string[]) {
    this.caches.push(...srcList);
  }
}
